import type { TOC } from '@ember/component/template-only';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import {
  PrismButton,
  PrismCard,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import SettingsMyotbBenchmarkSummary from 'lumen/components/settings/myotb/benchmark-summary';
import type HotelSettingsMyotbActiveController from 'lumen/controllers/hotel/settings/myotb/active';

interface HotelSettingsMyotbActiveSignature {
  Args: {
    controller: HotelSettingsMyotbActiveController;
    model: unknown;
  };
}

<template>
  <PrismCard @contentLayout="noPadding" class="myotb-card">
    <:content>
      <div class="flex justify-center" {{didInsert @controller.setDefaults}}>
        <PrismMessage
          @description={{t "settings.my_otb.setup_active.content"}}
          @illustration="100x100_success"
          @title={{t "settings.my_otb.setup_active.title"}}
        >
          <:link>
            <GeneralNavigationIntercomHelpLink
              @articleLink="en/articles/4086741-integrate-your-otb-in-the-rates-tab"
              @iconName="link-out"
              @isStandaloneLink={{true}}
              @linkText={{t "settings.my_otb.setup_active.learn_more_link"}}
              @type="text-and-icon"
            />
          </:link>
        </PrismMessage>
      </div>
    </:content>
  </PrismCard>

  {{#if @controller.showBenchmarkSummary}}
    <SettingsMyotbBenchmarkSummary
      @isInterestedInBenchmark={{@controller.isInterestedInBenchmark}}
      @isSetupComplete={{true}}
      @toggleBenchmarkInterest={{@controller.toggleBenchmarkInterest}}
    >
      <div class="flex justify-end">
        <PrismButton
          @isDisabled={{not @controller.isSaveEnabled}}
          @isLoading={{@controller.isLoading}}
          @label={{@controller.saveButtonText}}
          @onClick={{@controller.onClickNext}}
        />
      </div>
    </SettingsMyotbBenchmarkSummary>
  {{/if}}
</template> satisfies TOC<HotelSettingsMyotbActiveSignature>;
